import { RefObject } from 'react';
import { FormattedMessage } from 'react-intl';

export interface SubscriptionsProps {
  pricingRef: RefObject<HTMLDivElement | null>;
  onSignUpClick: () => void;
}

interface Plan {
  name: string;
  price: string;
  per: string;
  sub: string;
  feats: string[];
  featured?: boolean;
  tag?: string;
}

const PLANS: Plan[] = [
  {
    name: 'Starter',
    price: '$19',
    per: '/mes',
    sub: 'Para empezar con un puñado de atletas.',
    feats: ['Hasta 10 atletas', 'Plantillas ilimitadas', 'Calendario y asignación', 'Progreso básico']
  },
  {
    name: 'Pro',
    price: '$39',
    per: '/mes',
    sub: 'Para coaches que viven de entrenar gente.',
    feats: [
      'Hasta 30 atletas',
      'Asignación masiva por ciclo',
      'Carga subjetiva, tempo y progresiones',
      'Sesión en vivo',
      'Soporte WhatsApp'
    ],
    featured: true,
    tag: 'RECOMENDADO'
  },
  {
    name: 'Studio',
    price: '$79',
    per: '/mes',
    sub: 'Para estudios y boxes con varios coaches.',
    feats: ['Hasta 100 atletas', 'Multi-coach', 'Branding propio', 'Reportes exportables', 'API y webhooks']
  },
  {
    name: 'Unlimited',
    price: '$149',
    per: '/mes',
    sub: 'Cuando ya no querés pensar en límites.',
    feats: [
      'Atletas ilimitados',
      'Todo lo de Studio',
      'Onboarding 1-on-1',
      'Success manager dedicado',
      'SLA prioritario'
    ]
  }
];

const Subscriptions = ({ pricingRef, onSignUpClick }: SubscriptionsProps) => {
  return (
    <section className="sec sec-pricing light" id="precios" data-screen-label="07 Precios" ref={pricingRef}>
      <div className="container">
        <div className="sec-head">
          <div className="eyebrow on-light">
            <span className="eyebrow-dot" />
            <FormattedMessage id="landing.pricing.eyebrow" defaultMessage="PRECIOS" />
          </div>
          <h2 className="h2">
            <FormattedMessage id="landing.pricing.title" defaultMessage="Pagás por los atletas que entrenás." />
          </h2>
          <p className="lede">
            <FormattedMessage
              id="landing.pricing.lede"
              defaultMessage="Sin contrato. Cancelás cuando quieras. Cobramos por tu volumen real, no por feature."
            />
          </p>
        </div>

        <div className="pricing-grid">
          {PLANS.map((p) => (
            <div key={p.name} className={`plan${p.featured ? ' featured' : ''}`}>
              {p.tag && <div className="plan-tag">{p.tag}</div>}
              <div className="plan-name">{p.name}</div>
              <div className="plan-price">
                <span className="num">{p.price}</span>
                <span className="per">{p.per}</span>
              </div>
              <div className="plan-sub">{p.sub}</div>
              <ul className="plan-feats">
                {p.feats.map((f) => (
                  <li key={f}>{f}</li>
                ))}
              </ul>
              <button className="plan-cta" type="button" onClick={onSignUpClick}>
                <FormattedMessage id="landing.pricing.cta" defaultMessage="Empezar" />
              </button>
            </div>
          ))}
        </div>

        <p className="pricing-note">
          <FormattedMessage
            id="landing.pricing.note"
            defaultMessage="Todos los planes incluyen {trial} sin tarjeta. ¿Más de 100 atletas? Hablemos."
            values={{ trial: <strong>30 días gratis</strong> }}
          />
        </p>
      </div>
    </section>
  );
};

export default Subscriptions;
